import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { PRODUCT_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class SeriesService {
    private readonly URL_PATH = `${PRODUCT_URL}/series`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    /**
     * 🔹 Get all Series
     */
    public getAllSeries(

    ): Observable<any> {
        return this.http
            .get<any>(`${this.URL_PATH}/getAll`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * 🔹 Add new Series
     */
    public addSeries(data: { name: string; }): Observable<any> {
        return this.http
            .post<any>(`${this.URL_PATH}/save`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * 🔹 Update Series
     */
    public updateSeries(data: { id: number; name: string; }): Observable<any> {
        return this.http
            .post<any>(`${this.URL_PATH}/update`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * 🔹 Delete Series
     */
    public deleteSeries(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.URL_PATH}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }

}
